const EntityNames = {
  moment: {
    name: 'Moment',
    singular: 'moment',
    plural: 'moments',
  },
  story: {
    name: 'Story',
    singular: 'story',
    plural: 'stories',
  },
  account: {
    name: 'Account',
    singular: 'account',
    plural: 'accounts',
  },
  service: {
    name: 'Channel',
    singular: 'service',
    plural: 'services',
  },
  placement: {
    name: 'Placement',
    singular: 'placement',
    plural: 'placements',
  },
  content: {
    name: 'Content',
    singular: 'content',
    plural: 'content',
  },
}

const findByName = (name) =>
  Object.values(EntityNames).find((grouping) => grouping.name === name)

export default {
  ...EntityNames,
  findByName,
}
